import type { TOC } from '@ember/component/template-only';
import { get } from '@ember/helper';
import { and } from 'ember-truth-helpers';
import HotelChannelPricingTooltipsChannelOffsetTooltip from 'lumen/components/hotel/channel-pricing/tooltips/channel-offset-tooltip';
import type { FormattedOffset } from 'lumen/models/channel-pricing-subscription-config';

interface HotelChannelPricingTablesCellsMinorChannelsTableTdTableNameCellSignature {
  Args: {
    row: {
      channelId?: string;
      channelOffsetsByChannel?: Record<string, FormattedOffset>;
    };
    value: string;
  };
}

const RestrictionsRowCellContent = <template>
  <div class="text-200--medium flex flex-row items-center">
    <p class="truncate" title={{@value}}>
      {{@value}}
    </p>

    {{#if (and @row.channelId @row.channelOffsetsByChannel)}}
      <HotelChannelPricingTooltipsChannelOffsetTooltip
        @label={{@value}}
        {{! @glint-expect-error: Incorrect type }}
        @offset={{get @row.channelOffsetsByChannel @row.channelId}}
      />
    {{/if}}
  </div>
</template> satisfies TOC<HotelChannelPricingTablesCellsMinorChannelsTableTdTableNameCellSignature>;

export default RestrictionsRowCellContent;
